module.exports = __webpack_public_path__ + "static/media/wtms-logo.750bc286.png";